import { Component, createSignal, onCleanup, onMount } from 'solid-js'

import { InstagramIcon, TelegramIcon, WhatsappIcon } from 'icons'
import './style/footer.scss'

const Footer: Component = () => {
    const [active, setActive] = createSignal(false)

    let containerRef: HTMLElement
    let logoRef: HTMLDivElement

    onMount(() => {
        if (!logoRef || !containerRef) return

        let ac = new AbortController()

        document.addEventListener('scroll', handleScr, {
            passive: true,
            signal: ac.signal,
        })

        onCleanup(() => {
            ac.abort()
        })
    })

    const handleScr = () => {
        let divide = innerWidth > 768 ? 4 : 3
        let y = containerRef.getBoundingClientRect().top - innerHeight / divide

        if (y > innerHeight || y < -innerHeight) return

        let yVal = Math.min(Math.max(y, 0), logoRef.clientHeight + 32)

        logoRef.style.transform = `translateY(${yVal}px)`

        if (yVal <= 0) setActive(true)
    }

    return (
        <footer
            class='footer-container'
            id='contact'
            ref={e => (containerRef = e)}
        >
            <div class='logo-container' ref={e => (logoRef = e)}>
                <img
                    src='/public/imgs/logoText.png'
                    loading='lazy'
                    decoding='async'
                    alt='بیمه همراه لوگو'
                />
            </div>
            <div class='footer-wrapper' classList={{ active: active() }}>
                <div class='address-wrapper'>
                    <h3 class='head section_title'>
                        <span>آدرس شرکت</span>
                    </h3>
                    <p class='add title_smaller'>
                        استان تهران ، شهر تهران ، عباس آباد ، خیابان بهشتی ،
                        خیابان پاکستان ، کوچه مزار شریف ( چهارم ) ، پلاک ۱۵ ،
                        طبقه همکف واحد 2
                        <br /> کدپستی : ۱۵۳۱۶۴۶۴۱۳{' '}
                    </p>
                </div>

                <div class='socials-wrapper'>
                    <div class='phones'>
                        <div class='phones-column corp'>
                            <h4 class='header title_hero'>
                                <span>تلفن مستقیم</span>
                            </h4>
                            <a href='tel:02188747821' class='phone title_small'>
                                <span>02188747821</span>
                            </a>
                            <a href='tel:02188747822' class='phone title_small'>
                                <span>02188747822</span>
                            </a>
                            <a href='tel:02188525766' class='phone title_small'>
                                <span>02188525766</span>
                            </a>
                        </div>
                        <div class='phones-column mang'>
                            <h4 class='header title_hero'>
                                <span>مدیریت</span>
                            </h4>
                            <a href='tel:09102059267' class='phone title_small'>
                                <span>09102059267</span>
                            </a>
                        </div>
                    </div>
                    <div class='socials'>
                        <a
                            href='https://wa.me/PHONE_NUMBER'
                            rel='noopener noreferrer'
                            class='social what'
                        >
                            <div class='bg'></div>
                            <WhatsappIcon />
                        </a>
                        <a
                            href='https://t.me/username'
                            rel='noopener noreferrer'
                            class='social tel'
                        >
                            <div class='bg'></div>
                            <TelegramIcon />
                        </a>
                        <a
                            href='https://instagram.com/your_username'
                            rel='noopener noreferrer'
                            class='social insta'
                        >
                            <div class='bg'></div>
                            <InstagramIcon />
                        </a>
                        <button class='social rubika'>
                            <div class='bg'></div>
                            <img
                                src='/public/imgs/socials/rubika.png'
                                loading='lazy'
                                decoding='async'
                                alt='روبیکا بیمه همراه'
                            />
                            <div class='tooltip title_small'>09123456789</div>
                        </button>
                        <button class='social bale'>
                            <div class='bg'></div>
                            <img
                                src='/public/imgs/socials/bale.png'
                                loading='lazy'
                                decoding='async'
                                alt='بله بیمه همراه'
                            />
                            <div class='tooltip title_small'>09123456789</div>
                        </button>
                        <button class='social eita'>
                            <div class='bg'></div>
                            <img
                                src='/public/imgs/socials/eita.png'
                                loading='lazy'
                                decoding='async'
                                alt='ایتا بیمه همراه'
                            />
                            <div class='tooltip title_small'>09123456789</div>
                        </button>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
